import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";
import RolePicker from "../RolePicker";

export default function StaffTasksSection({
  channels = [],
  roles = [],
  staffTasks,
  setStaffTasks,
  isOpen,
  setIsOpen,
  setHasUnsavedChanges,
}) {
  const update = (field, value) => {
    setStaffTasks({ ...staffTasks, [field]: value });
    if (setHasUnsavedChanges) setHasUnsavedChanges(true);
  };

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Post staff to-dos with <code>/todo create</code>. Tasks appear in the
        board channel with Claim, Unclaim, Completed, and Reopen buttons.
        Reopening deletes the old message and posts a fresh open task at the
        bottom.
      </p>

      <label className="input-label">TASK BOARD CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={staffTasks.channelId || ""}
        onChange={(v) => update("channelId", v)}
        emptyLabel="None"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        ROLES THAT CAN CREATE TASKS
      </label>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "10px" }}
      >
        Members with any of these roles (or Manage Server) can run{" "}
        <code>/todo create</code> and use claim / complete / reopen buttons.
      </p>
      <RolePicker
        roles={roles}
        multiple
        value={staffTasks.creatorRoleIds || []}
        onChange={(ids) => update("creatorRoleIds", ids)}
        placeholder="Select roles..."
        emptyLabel="None (Manage Server only)"
      />
    </SettingsSection>
  );
}
